module.exports = __webpack_public_path__ + "static/services-cs-kroger-9290d3ce2c61735d14a715c6833e4ea9.png";